/** Location attribute type holding the prescription template, where display formats live. */
export const PRESCRIPTION_TEMPLATE_ATTRIBUTE_TYPE = 'Prescription_Customization_Settings';

/** Every custom section shares this encounter type; sections are told apart by their obs concepts. */
export const CUSTOM_SECTION_ENCOUNTER_TYPE_UUID = '604a8477-8aaa-4d16-a34b-110dbd380934';

export const CUSTOM_SECTION_ID_PREFIX = 'custom:';

/** Built-in sections order up to 20; custom ones follow unless a doctor reorders them. */
export const CUSTOM_SECTION_ORDER_BASE = 100;

/** The visit query's representation omits obs, so they are requested explicitly here. */
export const CUSTOM_SECTION_ENCOUNTER_REPRESENTATION =
  'custom:(uuid,display,encounterDatetime,visit:(uuid),obs:(uuid,concept:(uuid,display),value))';

/** Form field key. Derived from the uuid so renaming a field cannot reset form state. */
export const customSectionFieldName = (conceptUuid: string) => `field_${conceptUuid.replace(/-/g, '')}`;

/** Section id for the prescription registry and per-doctor overrides. Prefixed to avoid built-in ids. */
export const customSectionId = (conceptUuid: string) => `${CUSTOM_SECTION_ID_PREFIX}${conceptUuid}`;

export const isCustomSectionId = (sectionId: string) => sectionId.startsWith(CUSTOM_SECTION_ID_PREFIX);

/** Inverse of `customSectionId`, for keying stored preferences back to the concept. */
export const customSectionConceptUuid = (sectionId: string) => sectionId.slice(CUSTOM_SECTION_ID_PREFIX.length);

/** `PrescriptionRefs` is fixed-shape, so runtime sections are resolved by element id instead. */
export const customSectionElementId = (sectionId: string) => `${sectionId}-container`;
